import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import TextInput from '../components/inputs/TextInput';
import "../styles/login.css";
import EmailInput from '../components/inputs/EmailInput';
import LoginIcon from "../assets/login-icon.png";
import { CiLock } from "react-icons/ci";
import { Button } from 'antd';
import { postData } from '../helpers/api';
import { setLocalStorage } from '../helpers/localstorage';
import { useNavigate } from "react-router-dom";
import { openNotification } from '../helpers/alerts';
const SignupForm = () => {
    const navigate = useNavigate();
    const signin = async (email, password) => {
        try {
            const res = await postData('/auth/login', {
                email,
                password
            })
            setLocalStorage('auth', res.data)
            openNotification(`welcome ${res.data.user.name}`, 'success')
            navigate("/");
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <div className='login-page'>
            <div className="container">
                <div className="logo-section">
                    <div className="container">
                        <img src={LoginIcon} alt="" />
                        <h3>Bienvenue</h3>
                    </div>
                </div>
                <div className="form-section">
                    <Formik
                        initialValues={{
                            email: '',
                            password: ''
                        }}
                        validationSchema={Yup.object({
                            email: Yup.string().email('Invalid email address').required('Required'),
                            password: Yup.string().required('Required'),
                        })}
                        onSubmit={(values) => {
                            signin(values.email, values.password)
                        }}
                    >
                        {() => (
                            <Form>
                                <h3>Utilisateur en ligne</h3>
                                <EmailInput
                                    name="email"
                                    placeholder="Email"
                                    size="large"
                                />
                                <TextInput
                                    name="password"
                                    type="password"
                                    placeholder="Mot de passe"
                                    size="large"
                                    suffix={<CiLock />}
                                />
                                <Button htmlType="submit">Se connecter</Button>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
};

export default SignupForm;